export default __webpack_public_path__ + "static/media/Submarine-Beta_Standard.2d06dc31.svg";